import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M21.0001 4.52967L17.4646 0.994141L15.3432 3.11546L13.2219 0.994141L9.31493 4.90115L7.8009 3.38712L4.79958 8.39001L15.6098 19.2002L20.6122 16.1984L19.2144 14.8006L22.4143 11.6007L20.293 9.47942L22.4143 7.3581L20.293 5.23678L21.0001 4.52967ZM13.5576 9.14379L12.8505 8.43668L17.4646 3.82257L18.1717 4.52968L13.5576 9.14379ZM14.9718 10.558L18.8788 6.651L19.5859 7.3581L15.6789 11.2651L14.9718 10.558ZM17.8002 13.3864L17.0931 12.6793L18.8788 10.8936L19.5859 11.6007L17.8002 13.3864ZM11.4362 7.02247L10.7291 6.31536L13.2219 3.82257L13.929 4.52968L11.4362 7.02247Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M13.8421 20.261L3.73901 10.1579L0.740967 15.1553L8.84514 23.2595L13.8421 20.261Z"}}]};

const FriesFilled = Vue.extend<IconProps>({
  name: 'FriesFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'fries-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default FriesFilled;
